<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useChatStore } from '@/stores/chatStore.ts'
import ChatRoomIcon from '@/components/Sections/Communication/ChatRoom/ChatRoomIcon.vue'
import { computed } from 'vue'

/**
 * Stores
 */
const gameStore = useGameStore()
const chatStore = useChatStore()

/**
 * Computed
 */
const sortedRooms = computed(() => {
  // Convert Map to array, filter out deleted rooms, and sort
  const roomsArray = Array.from(chatStore.rooms.values())
    .filter(room => room.deleted === 0)
  
  // Sort rooms with unread messages to the top, then by most recent message
  return roomsArray.sort((a, b) => {
    const roomStatusA = chatStore.roomReadStatus.get(a.id)
    const roomStatusB = chatStore.roomReadStatus.get(b.id)
    
    const hasUnreadA = roomStatusA?.unreadStatus || false
    const hasUnreadB = roomStatusB?.unreadStatus || false
    
    // If A has unread but B doesn't, A comes first
    if (hasUnreadA && !hasUnreadB) return -1
    // If B has unread but A doesn't, B comes first
    if (!hasUnreadA && hasUnreadB) return 1
    
    // Secondary sort: by last message received id (higher = more recent)
    const lastMessageIdA = roomStatusA?.lastMessageReceivedId || 0
    const lastMessageIdB = roomStatusB?.lastMessageReceivedId || 0
    
    // Sort in descending order (newest first)
    return lastMessageIdB - lastMessageIdA
  })
})

/**
 * Methods
 */
const newChat = () => {
  // Logic to create a new chat room
  gameStore.modalType = 'newChat'
}

</script>

<template>
  <div class="w-12 mx-2 shrink-0">
   <StandardCard>
     <div class="height-limit overflow-y-scroll">
       <div class="flex justify-center">
         <ActionButton @click="newChat" class="w-9 h-9 flex items-center justify-center p-0">+</ActionButton>
       </div>
       <template v-for="room in sortedRooms" :key="room.id">
        <ChatRoomIcon :room="room"/>
      </template>
     </div>
   </StandardCard>
  </div>
</template>

<style scoped lang="scss">
.height-limit {
  height: calc(var(--vh, 1vh) * 100 - 7rem);
}
</style>